import { Divider, ListItem, ListItemText } from '@mui/material'
import { DateTime } from 'luxon'
import { Fragment, useEffect, useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { setInvoiceEmailMessage } from 'store/invoices/invoices.slice'
import { InvoiceResponse } from 'store/invoices/invoices.types'
import { cleanString } from 'utils/common'

const InvoiceEmailMessage = ({
  loadNumber,
  totalAmount,
  dueDate,
}: InvoiceResponse) => {
  const dispatch = useDispatch()

  const formattedDate = DateTime.fromISO(dueDate).toFormat('LLL dd, yyyy')

  const message = useMemo(() => {
    return `Your invoice amount for load# ${loadNumber} is $${totalAmount.toFixed(2)}. 
    This invoice is due on ${formattedDate}`
  }, [formattedDate, loadNumber, totalAmount])

  useEffect(() => {
    if (!!message) {
      dispatch(setInvoiceEmailMessage(cleanString(message)))
    }
  }, [dispatch, message])

  return (
    <Fragment>
      <ListItem>
        <ListItemText>Message: {message}</ListItemText>
      </ListItem>
      <Divider />
    </Fragment>
  )
}

export default InvoiceEmailMessage
